<template>
  <CModal :backdrop="true" :closeOnBackdrop="true" size="sm" :show.sync="localShow" :centered="true">
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="12" class="mb-1">
        <cSelectForm
          label="Sede"
          placeholder="Seleccione Sede"
          :options="data_campus"
          :value.sync="selectedCampu"
        />
      </CCol>
      <!-- <CCol xs="12" sm="12" md="12" lg="12" class="mb-1">
        <cSelectForm
          label="Almacen"
          placeholder="Seleccione Almacén"
          :options="data_almacenes"
          :value.sync="selectedAlmacen"
        />
      </CCol> -->
      <CCol sm="12">
        <label for="file">Archivo Excel</label>
        <input type="file" class="form-control" name="file" id="file" @change="onFileChange" accept=".xlsx,.xls" />
      </CCol>
    </CRow>
    <template #footer>
      <CButton color="secondary" @click="close">Cancelar</CButton>
      <CButton color="primary" :disabled="!selectedCampu || /* !selectedAlmacen || */ !file" @click="uploadProducts">Guardar</CButton>
    </template>
  </CModal>
</template>

<script>
import { mapActions } from 'vuex';
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";

export default {
  components: { cSelectForm },
  props: {
    show: { type: Boolean, default: false },
    campus: { type: Array, default: () => [] },
    companyId: Number
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    },
    filteredCampus() {
      return Array.isArray(this.campus)
        ? this.campus.filter(c => c.company_id === this.companyId)
        : [];
    }
  },
  data() {
    return {
      data_campus: [],
      data_almacenes: [],
      selectedCampu: "",
      selectedAlmacen: "",
      file: null
    }
  },
  created() {
    this.getCampus();
  },
  methods: {
    ...mapActions(["get", "post", "postWithFile"]),
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/users/bycampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data_campus = response.data.map((element) => ({
            label: element.name,
            value: element.id,
          }));
        }
      });
    },
    showAlmacenes() {
      this.data_almacenes = [];
      this.selectedAlmacen = ""; // Limpia la selección anterior
      this.get({
        url:
            this.$store.getters.get__url +
            "/movementsProjects/byAlmacens/" +
            this.selectedCampu,
        token: this.$store.getters.get__token,
      })
      .then((response) => {
          response.data.forEach((element) => {
              this.data_almacenes.push({
                  label: element.name,
                  value: element.id,
              });
          });
          // Selecciona automáticamente el primer almacén si hay resultados
          if (this.data_almacenes.length > 0) {
            this.selectedAlmacen = this.data_almacenes[0].value;
          }
      })
      .catch((errors) => {
          console.log(errors);
      });
    },
    async uploadProducts() {
      if (!this.selectedCampu) {
        alert('Debe seleccionar una sede.');
        return;
      }
      /* if (!this.selectedAlmacen) {
        alert('Debe seleccionar un almacén.');
        return;
      } */
      if (!this.file) {
        alert('Debe seleccionar un archivo.');
        return;
      }

      const formData = new FormData();
      formData.append('campu_id', this.selectedCampu);
      formData.append('almacen_id', this.selectedAlmacen);
      formData.append('file', this.file);
      
      this.postWithFile({
        url: this.$store.getters.get__url + "/products/uploadProducts",
        token: this.$store.getters.get__token,
        formData: formData,
      })
        .then((response) => {
          if (response.data) {
            Swal.fire(
              "Completado!",
              "El archivo ha sido subido correctamente.",
              "success"
            ).then(() => {
              this.$emit('mtd_getdata');
              this.close(); // Cierra el modal y limpia los campos después del OK
            });
          }
        })
        .catch((error) => {
          Swal.fire(
            "Error",
            "Ocurrió un error al subir el archivo.",
            "error"
          );
        });
    },
    close() {
      this.localShow = false;
      this.data_campus = [];
      this.data_almacenes = [];
      this.selectedCampu = "";
      this.file = null;
    },
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    upload() {
      this.$emit('upload', { campuId: this.selectedCampu, almacenId: this.selectedAlmacen, file: this.file });
      this.close();
    }
  }
}
</script>